import { createDarkTheme } from '../../utils/createDarkTheme';
import { brandWeb } from '../../global/brandColors';
export const webDarkTheme = createDarkTheme(brandWeb);
